import { JsonApiQuery } from '@nx-icilalune/data/access';
import { Solution } from '@nx-icilalune/data/icilalune/types';
import {
  allParagraphIncludes,
  associatedProjectsIncludes,
  projetRelationAttributeEnhancers,
} from './icilalune.queries';
import { ImageMedia } from '@nx-icilalune/drupal-types';

const solutionIncludes = ['thumbnail'];
export const solutionListQuery: JsonApiQuery = {
  queryId: 'solutionListQuery',
  type: Solution.type,
  include: solutionIncludes,
  fields: {
    [Solution.type]: ['path', 'thumbnail', 'langcode'],
    [ImageMedia.type]: ['fileRef', 'langcode'],
  },
  relationAttributeEnhancers: ['thumbnail.fileRef'],
  filters: {
    isPublished: '1',
  },
};

export const solutionDetailQuery: JsonApiQuery = {
  queryId: 'solutionDetailQuery',
  type: Solution.type,
  include: [
    ...solutionIncludes,
    'media',
    ...allParagraphIncludes,
    ...associatedProjectsIncludes,
    'logo.fileRef',
  ],
  relationAttributeEnhancers: [
    'media.fileRef',
    'thumbnail.fileRef',
    'logo.fileRef',
    ...projetRelationAttributeEnhancers,
  ],
  filters: {
    isPublished: '1',
  },
};
